export enum Features {
  TICKETING = 'ticketing',
  HEALTHANDSAFETY = 'health-and-safety',
  CAFE = 'cafe',
  PARCELS = 'parcels',
  PARKING = 'parking',
  LOCKERS = 'lockers',
  MANAGED_EVENTS = 'managed-events',
  DESKWORKS = 'deskworks',
}
